window.addEventListener('DOMContentLoaded', function () {
    //handle no discount field and cart content yet
    if (!document.querySelector('.input-discount')) {
        notifyDiscount();
        analyzeCart(cartJSON);
    }
});



(() => {



    async function removeGift(cart) {
        let giftThreshold = document.querySelector('.gamification').dataset.thresholdGift;
        let giftProducts = document.querySelector('.gamification').dataset.giftProducts;
        let cartTotal = cart.total_price;
        const cartContent = await (await fetch(`${Shopify.routes.root}cart.js`)).json();


        let giftProductsInCart = cartContent.items.filter((item) => { return giftProducts.split(',').indexOf(item.product_id.toString()) > -1; });
        console.log('cartContent ', cartContent, ' giftProductsInCart ', giftProductsInCart);

        if (parseInt(cartTotal) < parseInt(giftThreshold) && giftProductsInCart.length > 0) {
            //remove gift
            let sectionsToBundle = [];
            document.documentElement.dispatchEvent(new CustomEvent("cart:prepare-bundled-sections", { bubbles: true, detail: { sections: sectionsToBundle } }));
            const cartContent = await (await fetch(`${Shopify.routes.root}cart/change.js`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify({
                    id: giftProductsInCart[0].key,
                    quantity: 0,
                    sections: sectionsToBundle
                })
            })).json();
            document.documentElement.dispatchEvent(new CustomEvent("cart:change", {
                bubbles: true,
                detail: {
                    baseEvent: "line-item:change",
                    cart: cartContent
                }
            }));
        }
    }


    document.addEventListener('cart:change', async function (e) {
        if (document.querySelector('.gamification')) {
            removeGift(e.detail.cart);
        }
    });
    document.addEventListener('DOMContentLoaded', async function (e) {
        if (document.querySelector('.gamification')) {
            removeGift(cartJSON);
        }
    });
})();

